import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyDispatcherList from "./cargo-company-dispatcher-list";
import CargoCompanyDispatcherListParams from "./cargo-company-dispatcher-list-params";

const useCargoCompanyDispatcherList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<CargoCompanyDispatcherList>([]);

  const load = async (
    params: CargoCompanyDispatcherListParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await cargoCompanyService.getDispatcherList(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    isError,
    load,
  };
};

export default useCargoCompanyDispatcherList;
